/* Copyright (c) 2019-2023 VMware, Inc. All rights reserved. VMware Confidential */

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ErrorOccurredEvent } from "@app/services/dispatcher/events/error-occurred";
import { Dispatcher } from "@app/services/dispatcher/dispatcher";
import { SHOW_NOTIFICATION_TOKEN } from "@app/services/http/http-wrapper.service";
import { ErrorService } from "@app/services/error.service";

export const retryCount = 3;
export const retryWaitMilliSeconds = 1000;

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private dispatcher: Dispatcher,
                private errorService: ErrorService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const showErrorNotification: boolean = request.context.get(SHOW_NOTIFICATION_TOKEN);
        return next.handle(request).pipe(
            tap({
                    error: error => this.handleError(error, showErrorNotification)
                }));
    }

    handleError(error: HttpErrorResponse, showErrorNotification: boolean): void {
        const errorMsg: string = this.errorService.getConsoleErrorMessage(
            error,
            "console.api.error.unknown",
            "console.api.error.http");
        console.error(errorMsg, error);

        if (showErrorNotification) {
            if (error.status > 0) {
                this.dispatcher.publishEvent(ErrorOccurredEvent.fromHttpError(error));
            }
        }
    }
}
